import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.69656 6.01911L8.67438 2.19362C8.84834 2.02615 9.05491 1.8933 9.28229 1.80266C9.50967 1.71202 9.75339 1.66536 9.99953 1.66536C10.2457 1.66536 10.4894 1.71202 10.7168 1.80266C10.9442 1.8933 11.1507 2.02615 11.3247 2.19362L15.3034 6.01911C16.3523 7.02786 17.0666 8.31306 17.3559 9.7122C17.6453 11.1113 17.4967 12.5616 16.9291 13.8795C16.3614 15.1975 15.4001 16.3239 14.1667 17.1165C12.9334 17.909 11.4833 18.332 10 18.332C8.51666 18.332 7.06662 17.909 5.83326 17.1165C4.5999 16.3239 3.63861 15.1975 3.07094 13.8795C2.50327 12.5616 2.35473 11.1113 2.64408 9.7122C2.93344 8.31306 3.64771 7.02786 4.69656 6.01911Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.5 10.832H12.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 13.332V8.33203",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }